import Api from "./api";

class OrderService extends Api {}

export default new OrderService({
  ressource: "/admin/orders"
});
